import { Avatar, Box, IconButton, Stack, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { LogOut } from "lucide-react";
import { Dispatch } from "redux";

import { ILoggedUser, deleteLoggedUser } from "../../store/actions";
import { Position } from "../../views/Login/LoginUtils";
import "./ProfileButton.scss";

export default function ProfileButton() {
	const dispatch: Dispatch<any> = useDispatch();
	const loggedUser: ILoggedUser = useSelector(
		(state: any) => state.loggedUser.loggedUser,
	);
	const { instance } = useMsal();
	const logout = (): void => {
		instance.logoutRedirect();
		dispatch(deleteLoggedUser);
	};

	return (
		<Box className="home__header__user">
			<Avatar className="home__header__user__avatar">{loggedUser?.initials}</Avatar>
			<Stack>
				<Typography className="home__header__user__name">
					{loggedUser?.fullName}
				</Typography>
				<Typography className="home__header__user__position">
					{loggedUser?.position === Position.SUPERADMIN
						? "Super Admininistrador"
						: loggedUser?.position === Position.ADMIN
							? "Administrador"
							: loggedUser?.position === Position.COLAB
								? "Colaborador"
								: "Usuario"}
				</Typography>
			</Stack>
			<IconButton
				className="home__header__user__button"
				onClick={logout}
			>
				<LogOut />
			</IconButton>
		</Box>
	);
}
